import { render, staticRenderFns } from "./ExpenseByFailedTransfer.vue?vue&type=template&id=a233a7b4&lang=pug&"
import script from "./ExpenseByFailedTransfer.vue?vue&type=script&lang=ts&"
export * from "./ExpenseByFailedTransfer.vue?vue&type=script&lang=ts&"
import style0 from "./ExpenseByFailedTransfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports